import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=0c0275ab&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=0c0275ab&prod&lang=scss&scoped=true"
import style1 from "./productManage.vue?vue&type=style&index=1&id=0c0275ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0275ab",
  null
  
)

export default component.exports